import * as React from 'react';
import '../css/SuperUserPageView.css';
import HeaderBar from '../../HeaderBar/HeaderBar';
import DisclaimersTable from './DisclaimersTable'

export interface IManageDisclaimersProps {
}

export interface IManageDisclaimersState {

}

export default class ManageDisclaimers extends React.Component<IManageDisclaimersProps, IManageDisclaimersState> {
  render() {

	return (
	  <div className="root-container">
		<HeaderBar />
		<div className="inner-su-container">
			<DisclaimersTable/>
		</div>
	  </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageDisclaimers.tsx